export default __webpack_public_path__ + "images/b3ab7799b304231f06e24d8a1bacccbf-environmentsustainability.webp";